module.exports = __webpack_public_path__ + "img/Betreuung.912162ee.svg";